import React, { FC, ReactElement } from 'react'

import './StudentDashboardCustomAccordion.scss'

interface IStudentDashboardCustomAccordionProps {
  children: ReactElement
}

const StudentDashboardCustomAccordion: FC<IStudentDashboardCustomAccordionProps> = ({ children }) => {
  return (
    <div className="student-dashboard-custom-accordion--layout">
      {children}
    </div>
  )
}

export default StudentDashboardCustomAccordion
